import { render, staticRenderFns } from "./paper-repo.vue?vue&type=template&id=b9081ee8&"
import script from "./paper-repo.vue?vue&type=script&lang=js&"
export * from "./paper-repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports